/**
 * Store state for wordpress/pages module
 */
export const initialState = {
  pages: [
    // {
    //   ...page,
    //   components: '',
    //   header: '',
    //   css: '',
    //   extensions: ''
    // }
  ],
  selected: null
}

const state = {...initialState}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/pages/state.js